import React from "react";

import { SwitchOption as CoreSwitchOption, SwitchOptionProps } from "@jelly/ui";

import styles from "./SwitchOption.module.scss";

export const SwitchOption: React.FC<SwitchOptionProps> = (props) => {
  return <CoreSwitchOption {...props} style={styles} />;
};
